export default {
  tabs: {
    home: 'Início',
    menu: 'Menu',
    orders: 'Encomendas',
  },
};
